
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns22b87a103fb1f74c2a6dc30b18ea5a1fen from './en.yaml'
            i18n.addResourceBundle('en', '22b87a103fb1f74c2a6dc30b18ea5a1f', flattenObject(ns22b87a103fb1f74c2a6dc30b18ea5a1fen), true, true);
        
        export default '22b87a103fb1f74c2a6dc30b18ea5a1f';
    